export default src => (`data:image/svg+xml;base64,${window.btoa(src)}`)
